// extracted by mini-css-extract-plugin
export default {"botaoContainer":"nextButton_botaoContainer__vOiSH","buttonActive":"nextButton_buttonActive__ZMeQ2","buttonDisabled":"nextButton_buttonDisabled__jfhjA"};